export const mfManifestsPath = '/assets/module-federation.manifest.dev7.json'
